import $ from "jquery";
import moment from "moment";

if (window.currentPage == 'project_manager_proposal') {
    function formatNumber(x) {
        x = parseFloat(x);
        var parts = x.toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function calcPriceHistory(proposal_contract_type, history) {
        let data_price = JSON.parse(history.content);
        let tax = history.proposal.tax;
        let price_old_tax = 0;
        let price_new_tax = 0;
        if (proposal_contract_type == 1) {
            let price_old = data_price.contract_amount[0] || 0;
            price_old_tax = (price_old * tax) || 0;
            // $('.amountIncludeTax').text('（税込' +formatNumber(amount_tax) + '円）');
            let price_new = data_price.contract_amount[1] || 0;
            price_new_tax = (price_new * tax) || 0;   
        } else {
            let hourly_salary_old = data_price.hourly_salary[0] || 0;
            let working_time_month_old = data_price.working_time_month[0] || 0;
            price_old_tax = (hourly_salary_old * working_time_month_old * tax) || 0
            let hourly_salary_new = data_price.hourly_salary[1] || 0;
            let working_time_month_new = data_price.working_time_month[1] || 0;
            price_new_tax = (hourly_salary_new * working_time_month_new * tax) || 0;
        }
        return [formatNumber(price_old_tax), formatNumber(price_new_tax)];
    }

    $(document).ready(function () {
        $('.btnClose').on('click', function(e) {
            e.preventDefault();
        });
        $('.openProposal').on('click', function(e) {
            let key = $(this).attr('data-key');
            $('#modalAppContentEdit').css({"display": "none"});
            $.ajax({
                url: '/order/ajax/get-proposal/' + key,
                type: 'get',
                dataType: "json",
                beforeSend: function () {
                    $('.modal_text').text('');
                },
                }).done(async function (res) {
                    if (res.success) {
                        let data = res.data.data;
                        var is_partner = false;

                        if(data.assign_user_name && data.assign_role == role_partner) {
                            is_partner = true;
                        }

                        let list_price_history = res.data.history_price;
                        $('.modal_company_manager').html('<a href="' + data.link_company + '"><p class="text blue">' + data.company_name + '<p></a>');
                        $('.modal_name_manager').html('<a href="' + data.link_manager + '"><p class="text blue">' + data.manager_name + '</p></a>');

                        $('.modal_assign').html('<a href="'+data.link_assign+'"><p class="text blue">'+(is_partner ? data.assign_user_name : data.assign_name)+'</p></a>');
                        $('.modal_proposal_salary').text(data.salary);
                        if (data.file) {
                            $('.modal_proposal_file').attr('href', data.file).text(data.file_name);
                        }
                        $('.modal_link_company').attr('href', data.link_company).text(data.company_name);
                        $('.modal_proposal_content').html(data.content);
                        $('.modal_avatar_manager').attr('src', data.avatar);
                        $('.modal_avatar_manager').attr('alt', data.assign_name);
                        if (data.logo_company) {
                            $('.modal_company_logo_manager').attr('src', data.logo_company);
                            $('.modal_company_logo_manager').attr('alt', data.company_name);

                            $('.modal_company_logo_manager').css('display', 'block');
                        } else {
                            $('.modal_company_logo_manager').attr('src', '');
                            $('.modal_company_logo_manager').css('display', 'none');
                        }
                        $('.modal_gender_manager').text(`${data.gender} / ${data.pref} / ${data.birthday}`);
                        $('.modal_time_work').text(data.time_work + '時間/月');
                        $('.modal_wage_by_hour').text(data.minimum_wage_by_hour + '円');
                        $('.modal_is_remote').text(data.is_remote);
                        $('.modal_pref_can_work').text(`${data.pref_can_work ? data.pref_can_work : ''}`);
                        $('#modalAppContentEdit').css({"display": "block"});
                        $('#modalAppContentEdit').css({"pointer-events": "all"});

                        $('.txtDot').text(data.time_active);
                        let html = '';
                        let proposal_contract_type = data.contract_type;
                        if (list_price_history) {
                            for (let i = 0; i < list_price_history.length; i++) {
                                const history = list_price_history[i];
                                let array_price = calcPriceHistory(proposal_contract_type, history)
                                html+= `
                                    <li class="item">
                                        <span class="ttl jsTitle">編集： ${history.created_at_format} (${history.expert_update})</span>
                                        <div class="box jsBox">
                                            <p class="txt1">固定報酬制 ${array_price[0]}円</p>
                                            <p class="txt2">${array_price[1]}円 へ変更</p>
                                        </div>
                                    </li>
                                `;
                            }
                        }
                        $('#jsHistoryPay').empty();
                        $('#jsHistoryPay').append(html);
                    }
                });
        });
        
        $(document).on('click', '.btnCloseCustom', function(e) {
            e.preventDefault();
            $('#modalAppContentEdit').css({"display": "none"});
            $('#modalAppContentEdit').css({"pointer-events": "none"});

        })

        $('.jsDeleteProject').on('click', function (e) {
            e.preventDefault();
            if (confirm("本当にこの案件を取消してもよろしいですか？")) {
                var url = $(this).attr('href')
                return $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: url,
                type: 'post',
                dataType: "json",
                success: function (result) {
                    if (result.status == true) {
                        alert(result.message)
                        window.location.href = result.url;
                    } else {
                        alert(result.message)
                    }
                },
                }).fail(function (xhr, textStatus, errorThrown) {
                    alert('異常が起こりました。後でもう一度試してみてください。')
                });
            }
        })
        $('body').on('click', '.orderUndo', function(e){
            e.preventDefault();
            if (confirm('エキスパートの選定取り下げを本当にしてよろしいでしょうか？')) {
                var data = {
                    id: $(this).data('id')
                };
                var that = $(this)
                $.ajax({
                    headers: {
                      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    url: '/order/undo',
                    data: data,
                    type: 'post',
                    dataType: "json",
                    success: function (res) {
                        if (res.success == true) {
                            var td_approve = that.parents('td')
                            var td_status = that.parents('tr').find('.proposalStatus')
                            that.parents('tr').removeClass('disable')
                            td_approve.html('<div class="groupButton1"><span class="button13 orderApprove" data-id="'+data.id+'" data-status="4">選定する</span><span class="button14 orderApprove" data-id="'+data.id+'" data-status="5">見送る</span></div>')
                            td_status.html(res.status)
                        } else {
                            alert(res.message)
                        }
                    }
                }).fail(function (xhr, textStatus, errorThrown) {
                    var message = JSON.parse(xhr.responseText)
                });
            }
        });

        $(document).on('click', '#jsHistoryPay .jsTitle', function(e) {
            e.stopPropagation();
            const box = this.nextElementSibling;
            this.classList.toggle('active');
            if (this.classList.contains('active')) {
                box.classList.add('active');
            } else {
                box.classList.remove('active');
            }
        })
    });
}

if (window.currentPage == 'project_manager_proposal' || window.currentPage == 'order_chat_detail') {
    $('body').on('click', '.orderApprove', function(e){
        e.preventDefault();
        var text_confirm = '本当にこのエキスパートを選定しますか'
        if ($(this).data('status') == 5) {
            text_confirm = '本当にこのエキスパートを見送りますか'
        }
        if (confirm(text_confirm)) {
            var data = {
                ids: [$(this).data('id')],
                status:  $(this).data('status'),
                project_id: $('#tableProposal').data('project-id')
            };
            var that = $(this)
            $.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/order/approve',
                data: data,
                type: 'post',
                dataType: "json",
                success: function (res) {
                    if (res.success == true) {
                        if (window.currentPage == 'project_manager_proposal') {
                            var td_approve = that.parents('td')
                            var td_status = that.parents('tr').find('.proposalStatus')
                            td_approve.parents('tr').addClass('disable')
                            var html_approve = '<span class="bold">選定済</span><br><a class="title orderUndo" href="javascript:void(0)" data-id="'+data.ids[0]+'">選定を取り下げ</a>'
                            var html_status = '<p class="tagSatus4">承諾待ち</p>'
                            if (data.status == 5) {
                                html_approve = '<span class="bold">見送り済</span>'
                                html_status = '<p class="tagSatus">見送り</p>'
                            }
                            td_approve.html(html_approve)
                            td_approve.addClass('center')
                            td_status.html(html_status)

                        }else{
                            $('.blockProposal').remove()
                        }
                    } else {
                        alert(res.message)
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                var message = JSON.parse(xhr.responseText)
            });
        }
    })

    $('body').on('click', '.orderApproves', function(e){
        e.preventDefault();
        var ids = [];
        $('.checkItem:checked').each(function() {
            ids.push($(this).val());
        });
        if (ids.length == 0) {
            return false;
        }
        var text_confirm = '本当にこのエキスパートを選定しますか'
        if ($(this).data('status') == 5) {
            text_confirm = '本当にこのエキスパートを見送りますか'
        }
        if (confirm(text_confirm)) {
            var data = {
                ids: ids,
                status:  $(this).data('status'),
                project_id: $('#tableProposal').data('project-id')
            };
            var that = $(this)
            $.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/order/approve',
                data: data,
                type: 'post',
                dataType: "json",
                success: function (res) {
                    if (res.success == true) {
                        var tr, td_approve,td_status, html_status;
                        let ids_response = res.ids;

                        $.each(ids_response, function(key, id) {
                            tr = $('.checkItem[value="'+id+'"]').parents('tr');
                            tr.addClass('disable')
                            td_approve = tr.find('.tdApprove')
                            td_approve.addClass('center')
                            if (data.status == 5) {
                                td_approve.html('<span class="bold">選定済</span>')
                                html_status = '<p class="tagSatus">見送り</p>'
                            }else{
                                td_approve.html('<span class="bold">見送り済</span><br><a class="title orderUndo" data-id="'+id+'" href="javascript:void(0)">選定を取り下げ</a>')
                                html_status = '<p class="tagSatus4">承諾待ち</p>'
                            }
                            td_status = tr.find('.proposalStatus')
                            td_status.html(html_status)
                        });
                    } else {
                        alert(res.message)
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                var message = JSON.parse(xhr.responseText)
            });
        }
    })
}

if (window.currentPage == 'project_register' || window.currentPage =='expert_project_list') {
    $('.expertApprove').click(function(e){
        e.preventDefault();
        var text_confirm = '本当に応募を承諾してもよろしいですか'
        if ($(this).data('status') == 7) {
            text_confirm = 'この案件を見送りますか？'
        }
        if (confirm(text_confirm)) {
            var data = {
                id: $(this).data('id'),
                status:  $(this).data('status'),
            };
            var that = $(this)
            $.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/expert/approve',
                data: data,
                type: 'post',
                dataType: "json",
                success: function (res) {
                    if (res.success == true) {
                        $('.blockProposal').remove();
                        var element = document.getElementById('expertRejectWhenBudding');
                        if (element){
                          var element = document.getElementById("expertRejectWhenBudding");
                          element.classList.add("hidden");
                        }
                    } else if(res.success == false) {
                        location.reload();
                    } else {
                        alert(res.message)
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                var message = JSON.parse(xhr.responseText)
            });
        }
    })
}
